// @copyright  2006-2026 West Indies Software Engineering Company Limited. All rights reserved.

/*
 * The portal-only class test behind the D-06 bounce: does this permission map
 * hold `access.client-portal.*` grants and nothing else? A customer matching
 * it has no business on any app-module screen inside the practice's
 * organisation — their full-app home is their OWN organisation — so the route
 * guard sends them to their portal home instead of the forbidden page.
 *
 * Pure and exported, like `practice-standing.js` beside it, so the class test
 * is unit-testable without the router or store closure.
 */

const CLIENT_PORTAL_PREFIX = 'access.client-portal.';

/*
 * `access.headoffice` is synthetic — `Libraries/Permissions.php` injects it
 * for every member — so it must be excluded when deciding "holds nothing
 * else", or every portal client would read as holding something else. An
 * explicit list rather than a prefix, deliberately: if another synthetic code
 * appears, this classifier fails loudly in its unit table instead of silently
 * reclassifying users.
 */
const SYNTHETIC_CODES = ['access.headoffice'];

export function isPortalOnly(permissionMap) {
    if (permissionMap === null || typeof permissionMap !== 'object') {
        return false;
    }

    const held = Object.keys(permissionMap).filter((code) => permissionMap[code] && !SYNTHETIC_CODES.includes(code));

    return held.length > 0 && held.every((code) => code.startsWith(CLIENT_PORTAL_PREFIX));
}
